// TODO: Look for other implementations of this enum.

// Mapping the asset class names and colours
export const AssetClassNames = {
  EQUITY: "Equity",
  FIXED_INCOME: "Fixed Income",
  PRECIOUS_METALS: "Commodities",
  CASH: "Cash",
  ALTERNATIVE_INV: "Alternative Inv",
};

export const AssetClassColour = {
  EQUITY: "#097896",
  FIXED_INCOME: "#00475a",
  PRECIOUS_METALS: "#91c840",
  CASH: "#DBE794",
  ALTERNATIVE_INV: "#E37B17",
};

export const FixedIncomeTypeNames = {
  BOND: "Bond",
  DEPOSIT: "Deposit",
  FUND: "Fund / ETF",
};

export const AssetClassColourArray = [
  AssetClassColour.EQUITY,
  AssetClassColour.ALTERNATIVE_INV,
  AssetClassColour.FIXED_INCOME,
  AssetClassColour.PRECIOUS_METALS,
  AssetClassColour.CASH,
];

export const AssetClassNameArray = [
  AssetClassNames.EQUITY,
  AssetClassNames.ALTERNATIVE_INV,
  AssetClassNames.FIXED_INCOME,
  AssetClassNames.PRECIOUS_METALS,
  AssetClassNames.CASH,
];



// WEBPACK FOOTER //
// ./src/app/common/enums/AssetClassType.ts